import { useState } from "react"; // لإدارة حالة البيانات داخل المكون
import { useAuth } from "../Context/Auth"; // للوصول لدوال المصادقة من الـ Context
import { Link, useNavigate } from "react-router-dom"; // للتنقل البرمجي بين الصفحات

export default function Login() {
  const navigate = useNavigate(); // دالة التنقل
  const { loginUser, loading, error, success } = useAuth(); // استخدام loginUser من context

  // الحالة الخاصة ببيانات المستخدم
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  // تحديث بيانات المستخدم عند الكتابة في الحقول
  const getUserData = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  // تنفيذ تسجيل الدخول عند الضغط على الزر
  const submitLoginForm = async (e) => {
    e.preventDefault();

    if (!credentials.email.trim() || !credentials.password.trim()) {
      alert("يرجى ملء جميع الحقول بشكل صحيح");
      return;
    }

    const result = await loginUser(credentials);
    if (result) {
      navigate("/home");
    }
  };

  return (
    <section className="vh-100">
      <div className="container-fluid h-custom">
        <div className="row d-flex justify-content-center align-items-center h-100">
          {/* صورة جانبية */}
          <div className="col-md-9 col-lg-6 col-xl-5">
            <img
              src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.webp"
              className="img-fluid"
              alt="Sample"
            />
          </div>

          {/* نموذج تسجيل الدخول */}
          <div className="col-md-8 col-lg-6 col-xl-4 offset-xl-1">
            <h3 className="mb-4">تسجيل الدخول</h3>

            {/* عرض رسائل الخطأ أو النجاح */}
            {error && <div className="alert alert-danger">{error}</div>}
            {success && <div className="alert alert-success">{success}</div>}

            <form onSubmit={submitLoginForm}>
              <div className="form-outline mb-4">
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter a valid email address"
                  onChange={getUserData}
                  className="form-control form-control-lg"
                />
                <label className="form-label" htmlFor="email">Email address</label>
              </div>

              <div className="form-outline mb-3">
                <input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Enter password"
                  onChange={getUserData}
                  className="form-control form-control-lg"
                />
                <label className="form-label" htmlFor="password">Password</label>
              </div>

          

              <div className="text-center text-lg-start mt-4 pt-2">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-primary btn-lg"
                  style={{ paddingLeft: "2.5rem", paddingRight: "2.5rem" }}
                >
                  {loading ? <i className="fas fa-spinner fa-spin"></i> : "Login"}
                </button>

                <p className="small fw-bold mt-2 pt-1 mb-0">
                  Don't have an account?
                  <Link to="/">
                  <a className="link-danger">Register</a>
                  </Link>
                  
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* الفوتر السفلي */}
      {/* <div className="d-flex flex-column flex-md-row text-center text-md-start justify-content-between py-4 px-4 px-xl-5 bg-primary">
        <div className="text-white mb-3 mb-md-0">
          © 2020. All rights reserved.
        </div>
        <div>
          <a href="#!" className="text-white me-4"><i className="fab fa-facebook-f"></i></a>
          <a href="#!" className="text-white me-4"><i className="fab fa-twitter"></i></a>
          <a href="#!" className="text-white me-4"><i className="fab fa-google"></i></a>
          <a href="#!" className="text-white"><i className="fab fa-linkedin-in"></i></a>
        </div>
      </div> */}
    </section>
  );
}
